import type { ObservabilitySnapshot } from "./observabilityReadModel";

export type ObservabilityReadiness = "ready" | "attention" | "unavailable";

export type ObservabilityEvaluation = {
  readiness: ObservabilityReadiness;
  label: string;
  detail: string;
  baselineActive: false;
  alertsActive: false;
};

export function evaluateObservabilitySnapshot(snapshot: ObservabilitySnapshot): ObservabilityEvaluation {
  const sourceCount = snapshot.sources.length;
  const unavailable = snapshot.summary.unavailable;
  const degraded = snapshot.summary.degraded;

  if (sourceCount === 0 || unavailable === sourceCount) {
    return {
      readiness: "unavailable",
      label: "Sources indisponibles",
      detail: "Aucune source locale ne peut encore produire d’agrégat. La baseline demeure inactive.",
      baselineActive: false,
      alertsActive: false,
    };
  }

  if (unavailable > 0 || degraded > 0) {
    return {
      readiness: "attention",
      label: "Couverture partielle",
      detail: `${unavailable} source(s) indisponible(s) et ${degraded} source(s) dégradée(s).`,
      baselineActive: false,
      alertsActive: false,
    };
  }

  return {
    readiness: "ready",
    label: "Snapshot disponible",
    detail: "Toutes les sources configurées ont retourné un agrégat. La baseline reste néanmoins inactive.",
    baselineActive: false,
    alertsActive: false,
  };
}

export function formatCandidateTarget(candidateTarget: number) {
  return `${(candidateTarget * 100).toFixed(candidateTarget === 1 ? 0 : 1)} %`;
}
